var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Grid, Select, Popup } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import { isValidEmail } from 'app/helpers/globalHelpers';
import { beginExtend } from 'app//actions/sandboxItemActions';
import { industryOptionsObject, jobFunctionOptionsObject, countryOptionsObject, } from '../../constants/extendFormConstants';
import Spacer from '../../components/Spacer/Spacer';
import { closeModal } from '../../actions/modalActions';
var SandboxExtend = /** @class */ (function (_super) {
    __extends(SandboxExtend, _super);
    function SandboxExtend(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            email: '',
            country: '',
            company: '',
            industry: '',
            telephone: '',
            jobrole: '',
            whyneo4j: '',
            isLoadingMarketo: true,
        };
        _this.handleExtend = _this.handleExtend.bind(_this);
        return _this;
    }
    SandboxExtend.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ isLoadingMarketo: false });
                return [2 /*return*/];
            });
        });
    };
    SandboxExtend.prototype.isAllowSubmit = function () {
        var _a = this.state, email = _a.email, country = _a.country, company = _a.company, industry = _a.industry, jobrole = _a.jobrole, whyneo4j = _a.whyneo4j, telephone = _a.telephone;
        return (email &&
            country &&
            company &&
            industry &&
            jobrole &&
            whyneo4j &&
            telephone &&
            company.length > 1 &&
            whyneo4j.length > 1 &&
            isValidEmail(email));
    };
    SandboxExtend.prototype.handleExtend = function (e) {
        e.preventDefault();
        var _a = this.props, sandboxData = _a.sandboxData, user = _a.user, onExtendConfirm = _a.onExtendConfirm, onCloseModal = _a.onCloseModal;
        if (!sandboxData)
            return;
        var _b = this.state, isLoadingMarketo = _b.isLoadingMarketo, formData = __rest(_b, ["isLoadingMarketo"]);
        var sandboxHashKey = sandboxData.sandboxHashKey, usecase = sandboxData.usecase;
        onExtendConfirm(user.accessToken, __assign(__assign({}, formData), { sandboxHashKey: sandboxHashKey, usecase: usecase }));
        onCloseModal();
    };
    SandboxExtend.prototype.renderActionBtn = function () {
        return (React.createElement(Button, { disabled: !this.isAllowSubmit(), onClick: this.handleExtend, color: "blue", size: "small" }, "Extend My Sandbox"));
    };
    SandboxExtend.prototype.render = function () {
        var _this = this;
        var _a = this.state, email = _a.email, company = _a.company, country = _a.country, industry = _a.industry, jobrole = _a.jobrole, whyneo4j = _a.whyneo4j, telephone = _a.telephone, isLoadingMarketo = _a.isLoadingMarketo;
        var _b = this.props, open = _b.open, onClose = _b.onClose;
        return (React.createElement(Modal, { open: open, onClose: onClose, closeIcon: true },
            React.createElement(Modal.Header, null, "Extend Now"),
            React.createElement(Modal.Content, null,
                React.createElement(Form, { loading: isLoadingMarketo },
                    React.createElement(Grid, null,
                        React.createElement(Grid.Column, { width: 8 },
                            React.createElement("span", { className: "font-x-small color-danger" }, "All fields are required")),
                        React.createElement(Spacer, { className: "my1" }),
                        React.createElement(Grid.Column, { width: 8, md: 6 },
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Work Email "),
                                React.createElement(Form.Input, { type: "email", value: email, onChange: function (e) { return _this.setState({ email: e.target.value }); } }))),
                        React.createElement(Grid.Column, { width: 8, md: 6 },
                            React.createElement(Form.Field, null,
                                React.createElement(Form.Input, { label: "Company", type: "text", value: company, onChange: function (e, _a) {
                                        var value = _a.value;
                                        return _this.setState({ company: value });
                                    } }))),
                        React.createElement(Spacer, { className: "my1" }),
                        React.createElement(Grid.Column, { width: 8, md: 6 },
                            React.createElement(Form.Field, { label: "Job Function", value: jobrole, control: Select, onChange: function (e, _a) {
                                    var value = _a.value;
                                    return _this.setState({ jobrole: value });
                                }, options: jobFunctionOptionsObject })),
                        React.createElement(Grid.Column, { width: 8, md: 6 },
                            React.createElement(Form.Field, { label: "Industry", control: Select, value: industry, onChange: function (e, _a) {
                                    var value = _a.value;
                                    return _this.setState({ industry: value });
                                }, options: industryOptionsObject })),
                        React.createElement(Spacer, { className: "my1" }),
                        React.createElement(Grid.Column, { width: 8, md: 6 },
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Country "),
                                React.createElement(Form.Field, { size: "large", value: country, control: Select, onChange: function (e, _a) {
                                        var value = _a.value;
                                        return _this.setState({ country: value });
                                    }, options: countryOptionsObject }))),
                        React.createElement(Grid.Column, { width: 8, md: 6 },
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Phone "),
                                React.createElement(Form.Input, { type: "text", placeholder: "", value: telephone, onChange: function (e) { return _this.setState({ telephone: e.target.value }); } }))),
                        React.createElement(Spacer, { className: "my1" }),
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "How has been your Neo4j experience so far? "),
                                React.createElement(Form.Input, { value: whyneo4j, as: "textarea", rows: "3", onChange: function (e) { return _this.setState({ whyneo4j: e.target.value }); } }))),
                        React.createElement(Spacer, { className: "my2" }),
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(Form.Field, null,
                                !this.isAllowSubmit() && (React.createElement(Popup, { inverted: true, position: "bottom center", content: "All fields are required", trigger: React.createElement("div", { className: "display-inline-block" }, this.renderActionBtn()) })),
                                this.isAllowSubmit() && this.renderActionBtn())))),
                React.createElement("p", { className: "font-small font-italic mt3" }, "This will extend you sandbox for an additional 7 days"))));
    };
    return SandboxExtend;
}(Component));
var mapDispatchToProps = function (dispatch) { return ({
    onExtendConfirm: function (token, data) { return dispatch(beginExtend(token, data)); },
    onCloseModal: function () { return dispatch(closeModal()); },
}); };
var mapStateToProps = function (state) { return ({
    sandboxData: state.activeModal.data,
    user: state.user,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxExtend);
